var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1228_480)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 28C0 20.7065 2.89731 13.7118 8.05456 8.55456C13.2118 3.39731 20.2065 0.5 27.5 0.5C34.7935 0.5 41.7882 3.39731 46.9454 8.55456C52.1027 13.7118 55 20.7065 55 28C55 35.2935 52.1027 42.2882 46.9454 47.4454C41.7882 52.6027 34.7935 55.5 27.5 55.5C20.2065 55.5 13.2118 52.6027 8.05456 47.4454C2.89731 42.2882 0 35.2935 0 28Z",
    fill: "#FF7215"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 29C28.2562 29 28.9039 28.7305 29.4429 28.1915C29.981 27.6534 30.25 27.0062 30.25 26.25C30.25 25.4937 29.981 24.8461 29.4429 24.3071C28.9039 23.769 28.2562 23.5 27.5 23.5C26.7437 23.5 26.0966 23.769 25.5585 24.3071C25.0195 24.8461 24.75 25.4937 24.75 26.25C24.75 27.0062 25.0195 27.6534 25.5585 28.1915C26.0966 28.7305 26.7437 29 27.5 29ZM27.5 42.2344C27.3167 42.2344 27.1333 42.2 26.95 42.1312C26.7667 42.0625 26.6062 41.9708 26.4687 41.8562C23.1229 38.9 20.625 36.156 18.975 33.6241C17.325 31.0914 16.5 28.725 16.5 26.525C16.5 23.0875 17.606 20.349 19.8179 18.3094C22.0289 16.2698 24.5896 15.25 27.5 15.25C30.4104 15.25 32.9711 16.2698 35.1821 18.3094C37.394 20.349 38.5 23.0875 38.5 26.525C38.5 28.725 37.675 31.0914 36.025 33.6241C34.375 36.156 31.8771 38.9 28.5312 41.8562C28.3937 41.9708 28.2333 42.0625 28.05 42.1312C27.8667 42.2 27.6833 42.2344 27.5 42.2344Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1228_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.822a60fb389df65518f5a1efd7fd25c0.svg";
export { ForwardRef as ReactComponent };